import MundXcode from "../icons/MundXcode";
import XtrackyIcon from "../icons/Xtracky";
import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";

export default function Xtracky() {
  return (
    <IntegrationTable
      integrationKey="xtracky"
      title="Xtracky"
      main_icon={<MundXcode />}
      icon={<XtrackyIcon />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
    />
  );
}
